const getters = {
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  user_nickname: (state) => state.user.user_nickname,
  user_id: (state) => state.user.user_id,
  userInfo: (state) => state.user.userInfo,
  formattedMessage: (state) => {
    return state.message ? `Message: ${state.message}` : "No message";
  },
};
export default getters;
